import { FC } from 'react';
import { FaqListItemResponseDto } from '@/features/faq/types/faq-dto';
import FaqOwnerCard from '@/features/faq/components/FaqOwnerCard';

type Props = {
	list?: FaqListItemResponseDto[];
	isMobile?: boolean;
};

const FaqOwnerList: FC<Props> = ({ list, isMobile }) => {
	return (
		<>
			{list?.map((faq) => (
				<FaqOwnerCard
					key={faq.id}
					isMobile={isMobile}
					{...faq}
				/>
			))}
		</>
	);
};

export default FaqOwnerList;
